import { jsx as i } from "react/jsx-runtime";
import { Box as g } from "@mui/material";
import { prettyDate as l } from "../../../helpers/dates.js";
import { MessageType as n } from "../../../helpers/daymaptypes.js";
import { useRef as m } from "react";
import { B as x } from "../../../pointsGraph-DTJju-rA.js";
const A = ({ messages: t, currentUser: r, threadId: a, onMessageClick: c }) => {
  const f = m(t.length - 1), d = [n.AdminPost, n.Admin, n.Alert, n.Absence, n.Excursion];
  return /* @__PURE__ */ i(g, { sx: { display: "flex", flexFlow: "column" }, children: t.map((e, o) => {
    const M = e.SenderID === r.ContactID;
    let p = !1;
    if (o > 0) {
      const s = t[o - 1];
      p = s.SenderID === r.ContactID && s.SentOn && e.SentOn && l(s.SentOn) === l(e.SentOn);
    }
    let S = d.includes(e.MessageType);
    return /* @__PURE__ */ i(x, { ...e, isSender: M, joinWithPrev: p, fadeIn: o > f.current, showOpenLink: a !== e.MessageID, sentBySchool: S, onOpenMessage: c }, e.MessageID);
  }) });
};
export {
  A as Thread
};
//# sourceMappingURL=Thread.js.map
